module.exports = __webpack_public_path__ + "static/media/menarche.bacdc7f8.svg";